import { Box } from "@mui/material";
import styled from "styled-components";

type AlignItemsType = "center" | "flex-end" | "flex-start" | "stretch";
type JustifyContentType =
  | "center"
  | "flex-end"
  | "flex-start"
  | "space-between";

/**
 * @deprecated
 * Use MUI <Box> with display, alignItems, justifyContent props instead.
 */
export const StyledFlex = styled.div<{
  alignItems?: AlignItemsType;
  justifyContent?: JustifyContentType;
  mdFlexFlow?: "row" | "column";
  gap?: string;
}>`
  display: flex;
  align-items: ${(props) => (props.alignItems ? props.alignItems : "")};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : ""};
  gap: ${(props) => (props.gap ? props.gap : "")};

  ${(props) => props.theme.breakpoints.down("lg")} {
    flex-flow: ${(props) => (props.mdFlexFlow ? props.mdFlexFlow : "")};
  }
`;

export const StyledInputLabel = styled.label<{ hasError?: boolean }>`
  font-weight: 400;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.hasError ? props.theme.colors.red : props.theme.palette.text.primary};
  margin-bottom: ${(props) => props.theme.spacing(1)};
  z-index: 1;

  .MuiTypography-body1 {
    font-weight: 400;
  }
`;

export const StyledPageWrapper = styled(Box)<{ $maxWidth?: string }>`
  max-width: ${(props) => props.$maxWidth ?? "600px"};
  min-width: ${(props) => (props.$maxWidth ? "unset" : "600px")};
  height: 100%;

  .left-content {
    padding-right: 0;
    order: 0;
  }

  ${(props) => props.theme.breakpoints.down("lg")} {
    .left-content {
      padding-right: 0;
    }
  }

  ${(props) => props.theme.breakpoints.down("md")} {
    max-width: ${(props) => props.$maxWidth ?? "600px"};
    min-width: ${(props) => (props.$maxWidth ? "unset" : "min(600px, 100%)")};

    .left-content {
      padding: 0;
    }

    .right-content + .left-content {
      display: none;
    }
  }

  ${(props) => props.theme.breakpoints.down("sm")} {
    width: 100%;
    max-width: unset;
    /* Shrink with the container — the minimum supported viewport width is
       enforced globally on body (see index.css), not by the wrapper */
    min-width: min(350px, 100%);

    .left-content {
      padding: 0;
    }

    .right-content + .left-content {
      display: none;
    }
  }
`;
